export const MAX_BUTTON_PRESSES = 3;

export const LILI_CARD_STYLES = {
  MAIN_CONTENT: 'flex bg-bw00 rounded-xl w-[684px] pc-md:w-[744px] h-[286px] p-[40px] gap-10',
  CARD_IMAGE_CONTAINER: 'relative flex-1 h-full',
  SPINNER: 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
  SPINNER_COLOR: '#ffffff',
  SPINNER_SIZE: '1rem',
  DISABLED_SPINNER_SIZE: '24px',
  CARD_IMAGE: 'h-full w-full',
  TEXT_CONTAINER: 'h-full flex flex-1 flex-col justify-between',
  TEXT_STYLES: 'flex flex-col font-metric mb-[1rem] text-bw08 text-base whitespace-pre-line',
  BUTTON:
    'h-[54px] w-[224px] bg-action03 text-bw00 text-md flex flex-row-reverse justify-center items-center gap-1 rounded font-metric',
  DISABLED_BUTTON:
    'h-[50px] w-[222px] bg-bw05 text-bw00 text-sm flex flex-row-reverse justify-center items-center gap-3 rounded font-metricSemibold',
  DISABLED_ORDER_REASON_BUTTON: 'text-bw05 bg-bw02',
};

export const LILI_CARD_MESSAGE = {
  FIRST_LINE: 'MY_LILI_CARD_PAGE_TITLE',
  BUTTON_SHOW_TEXT: 'MY_LILI_CARD_PAGE_BUTTON_SHOW_TEXT',
  BUTTON_HIDE_TEXT: 'MY_LILI_CARD_PAGE_BUTTON_HIDE_TEXT',
} as const;

export const CARD_ACTION_LOGIC_ENUMS = {
  VSE: {
    SHOW: 'show',
    HIDE: 'hide',
    SHOW_VSE_OFFER: 'Show VSE Offer',
  },
  ACTIONS: {
    SHOW: 'show',
    HIDE: 'hide',
    SET_PIN: 'set-pin',
  },
};

export const VSE_LINK = 'https://www.visasavingsedge.com/';

export const ACTIVATION_FLOWS = {
  SSN: 'ssn',
  EXPIRATION_DATE: 'expiration date',
};

export const ORDER_NEW_CARD_FLOWS = {
  F_STOLEN_LOST: 'stolen/lost',
  F_DAMAGED: 'damaged',
};

// export const COMING_SOON_MODAL_TEXTS = {
//   TITLE: 'MY_LILI_CARD_COMING_SOON_TITLE',
//   TEXT: 'MY_LILI_CARD_COMING_SOON_TEXT',
//   BTN: 'MY_LILI_CARD_COMING_SOON_BTN',
//
// };

export const ERROR_MODAL_TEXTS = {
  BTN: 'MY_LILI_CARD_ERROR_MODAL_BTN',
} as const;
export const LILI_CARD_CARD_ACTIONS = {
  CARD_FREEZE: 'MY_LILI_CARD_FREEZE_CARD',
  CHANGE_PIN: 'MY_LILI_CARD_CHANGE_PIN',
  ORDER_NEW_CARD: 'MY_LILI_CARD_ORDER_NEW_CARD',
  ACTIVATE_CARD: 'MY_LILI_CARD_ACTIVATE_CARD',
  PROCESSING: 'PROCESSING',
} as const;

export const NEW_CARD_ORDER_REASONS = {
  R_STOLEN: 'STOLEN',
  R_LOST: 'LOST',
  R_DAMAGED: 'DAMAGED',
} as const;

export const UI_TYPE = {
  FORM: 'form',
  TEXT_AREA: 'text area',
} as const;

export const STATES_ARRAY = [
  { STATE: 'Alabama', POSTAL: 'AL' },
  { STATE: 'Alaska', POSTAL: 'AK' },
  { STATE: 'Arizona', POSTAL: 'AZ' },
  { STATE: 'Arkansas', POSTAL: 'AR' },
  { STATE: 'California', POSTAL: 'CA' },
  { STATE: 'Colorado', POSTAL: 'CO' },
  { STATE: 'Connecticut', POSTAL: 'CT' },
  { STATE: 'Washington, D.C.', POSTAL: 'DC' },
  { STATE: 'Delaware', POSTAL: 'DE' },
  { STATE: 'Florida', POSTAL: 'FL' },
  { STATE: 'Georgia', POSTAL: 'GA' },
  { STATE: 'Hawaii', POSTAL: 'HI' },
  { STATE: 'Idaho', POSTAL: 'ID' },
  { STATE: 'Illinois', POSTAL: 'IL' },
  { STATE: 'Indiana', POSTAL: 'IN' },
  { STATE: 'Iowa', POSTAL: 'IA' },
  { STATE: 'Kansas', POSTAL: 'KS' },
  { STATE: 'Kentucky', POSTAL: 'KY' },
  { STATE: 'Louisiana', POSTAL: 'LA' },
  { STATE: 'Maine', POSTAL: 'ME' },
  { STATE: 'Maryland', POSTAL: 'MD' },
  { STATE: 'Massachusetts', POSTAL: 'MA' },
  { STATE: 'Michigan', POSTAL: 'MI' },
  { STATE: 'Minnesota', POSTAL: 'MN' },
  { STATE: 'Mississippi', POSTAL: 'MS' },
  { STATE: 'Missouri', POSTAL: 'MO' },
  { STATE: 'Montana', POSTAL: 'MT' },
  { STATE: 'Nebraska', POSTAL: 'NE' },
  { STATE: 'Nevada', POSTAL: 'NV' },
  { STATE: 'New Hampshire', POSTAL: 'NH' },
  { STATE: 'New Jersey', POSTAL: 'NJ' },
  { STATE: 'New Mexico', POSTAL: 'NM' },
  { STATE: 'New York', POSTAL: 'NY' },
  { STATE: 'North Carolina', POSTAL: 'NC' },
  { STATE: 'North Dakota', POSTAL: 'ND' },
  { STATE: 'Ohio', POSTAL: 'OH' },
  { STATE: 'Oklahoma', POSTAL: 'OK' },
  { STATE: 'Oregon', POSTAL: 'OR' },
  { STATE: 'Pennsylvania', POSTAL: 'PA' },
  { STATE: 'Rhode Island', POSTAL: 'RI' },
  { STATE: 'South Carolina', POSTAL: 'SC' },
  { STATE: 'South Dakota', POSTAL: 'SD' },
  { STATE: 'Tennessee', POSTAL: 'TN' },
  { STATE: 'Texas', POSTAL: 'TX' },
  { STATE: 'Utah', POSTAL: 'UT' },
  { STATE: 'Vermont', POSTAL: 'VT' },
  { STATE: 'Virginia', POSTAL: 'VA' },
  { STATE: 'Washington', POSTAL: 'WA' },
  { STATE: 'West Virginia', POSTAL: 'WV' },
  { STATE: 'Wisconsin', POSTAL: 'WI' },
  { STATE: 'Wyoming', POSTAL: 'WY' },
];

export const ZIP_CODE_REGEXP = /^[0-9]*$/;

export const DAYS_FROM_OPEN_ACCOUNT_IN_MS = 30 * 24 * 60 * 60 * 1000;

export const FLOW_STEPS = {
  ENROLL: 0,
  ENTER_DETAILS: 1,
  SET_PIN: 2,
};
export const SET_PIN_STYLES = {
  IFRAME: 'w-full h-full',
  IFRAME_TITLE: 'ChangePin',
  SPINNER_SIZE: '30px',
};
export const ENROLL_STYLES_TEXTS = {
  IMAGE_WRAPPER: 'flex h-full',
  IMAGE_CLASS_NAME: 'h-[210px] w-[337px]',
  BODY_WRAPPER: 'h-full w-[264px] flex flex-col',
  TEXTS_WRAPPER: 'flex flex-col',
  TITLE_STYLE: 'h-[24px] text-bw08 font-metricMedium text-[20px] mb-[14px]',
  TITLE: 'ACTIVATE_CARD_STEP0_HEADER',
  TEXT_STYLE: 'font-metric mb-[14px] text-bw08 text-base',
  TEXT: 'ACTIVATE_CARD_STEP0_TEXT',
  ACTIVATE_CTA_TEXT: 'ACTIVATE_CARD_STEP0_BUTTON_ACTIVATE',
  ACTIVATE_CTA: 'h-[50px] w-[200px] text-sm',
  NO_CARD_CTA_TEXT: 'ACTIVATE_CARD_STEP0_BUTTON_DIDNT_GET_CARD',
  NO_CARD_CTA: 'mt-[28px] h-[22px] text-bw06 hover:text-action03 text-sm flex items-center font-metric',
  NO_CARD_CTA_ICON: 'w-[16px] h-[16px] ml-[2px] text-bw06',
  MAILTO: 'mailto:support@lili.co?subject=My Lili card',
} as const;
export const CHANGE_PIN_STYLES_TEXTS = {
  BACK_BUTTON: 'flex items-center justify-center w-[2rem] h-[2rem]',
  BACK_BUTTON_ID: 'backChangePin',
  LAYOUT:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col gap-0',
  NAV_BAR: 'flex items-start mb-6 pt-[20px]',
  PAGE_TITLE: 'CHANGE_PIN_HEADER',
  PAGE_TITLE_STYLE: 'font-metricMedium text-xl',
  MAIN_CONTENT: 'flex flex-col gap-4',
  WRAPPER: 'flex bg-bw00 rounded-xl w-[744px] h-[496px] p-[40px] gap-10',
  // InfoPopup
  POPUP_HEIGHT: 'h-[486px]',
  POPUP_CLASS_NAME: 'pt-[87px] px-[34px]',
  POPUP_FLEX_PARAMS: 'flex flex-col items-center',
  POPUP_PICTURE: 'w-[84px] h-[84px]',
  MAIN_BUTTON_TEXT: 'CHANGE_PIN_POPUP_BUTTON_TEXT',
  MAIN_BUTTON_CLASS_NAME: 'text-bw00 text-sm font-metricSemibold',
  BUTTON_CLASS_NAME: 'w-[240px] h-[50px]',
  POPUP_TEXT: 'CHANGE_PIN_POPUP_TEXT',
  POPUP_TEXT_CLASS_NAME: 'mb-[76px] h-[54px] whitespace-pre-line',
  POPUP_TITLE: 'CHANGE_PIN_POPUP_HEADER',
  POPUP_TITLE_CLASS_NAME:
    'h-[27px] font-metricMedium text-bw08 mt-[30px] text-base leading-[27px] flex-inline text-center items-center mb-2',
} as const;

export const ACTIVATE_STYLES_TEXTS = {
  CONTAINER: 'flex flex-col w-full',
  HEADER_STYLE: 'h-[40px] text-bw08 font-metricSemibold text-[25px] mb-[0.5rem]',
  HEADER: 'ACTIVATE_CARD_STEP1_HEADER',
  TEXT_STYLE: 'h-[24px] text-bw07 font-metric text-base mb-[24px]',
  TEXT: 'ACTIVATE_CARD_STEP1_TEXT',
  PLACEHOLDER_STYLE: 'h-[25px] text-bw08 font-metricMedium text-base mb-[0.5rem]',
  PLACEHOLDER_EXP_DATE: 'ACTIVATE_CARD_STEP1_EXP_DATE_PLACEHOLDER',
  PLACEHOLDER_SSN: 'ACTIVATE_CARD_STEP1_SSN_PLACEHOLDER',
  DIGITS_CONTAINER_EXP_DATE_WRAPPER: 'h-[56px] flex items-center mb-[48px]',
  DIGITS_CONTAINER_SSN_WRAPPER: 'h-[56px] flex items-baseline mb-[48px]',
  DIGITS_CONTAINER: 'flex justify-between gap-2.5',
  SLASH_STYLE: 'font-metric text-bw03 text-[46px] leading-[56px] mx-2',
  SLASH: '/',
  PLACEHOLDER_LAST_4: 'ACTIVATE_CARD_STEP1_PIN_PLACEHOLDER',
  DIGITS_CONTAINER_LAST_4_WRAPPER: 'h-[56px] flex items-baseline mb-[0.5rem]',
  BLACK_DOT_CONTAINER: 'flex content-center items-baseline',
  BUTTONS_ERRORS_CONTAINER_EXP_DATE: 'w-full flex justify-end items-center mt-[20px]',
  BUTTONS_ERRORS_CONTAINER_SSN: 'w-full flex justify-end mt-[36px] items-center',
  ERRORS_CONTAINER_STYLE: 'h-[16px] text-red02 text-xxs font-metricMedium mr-auto',
  ERROR_TEXT_EXP_DATE: 'ACTIVATE_CARD_ERROR_MESSAGE_EXP_DATE',
  ERROR_TEXT_SSN: 'ACTIVATE_CARD_ERROR_MESSAGE_SSN',
  BACK_BUTTON_STYLE: 'mr-[30px] w-[100px]',
  BACK_BUTTON: 'ADD_MONEY_TRANSFER_MONEY_UM_ACTION_CANCEL',
  ACTIVATION_BUTTON_STYLE: 'h-[50px] w-[200px]',
  ACTIVATION_BUTTON_STYLE_SSN:
    'h-[50px] w-[200px] rounded-umd flex justify-center items-center bg-action03 hover:bg-action04 disabled:bg-bw05',
  ACTIVATION_BUTTON_TEXT_STYLE: 'text-bw00 text-sm font-metricSemibold',
  ACTIVATION_BUTTON_TEXT: 'TAX_BUCKET_PERSONALIZATION_CONTINUE_BUTTON_TEXT',
  SPINNER_WRAPPER: 'flex items-center justify-center flex-row-reverse',
  PROCESSING_STYLE: 'font-metricBold text-bw00 ml-[12px]',
  PROCESSING: 'PROCESSING',
  SPINNER_STYLE: 'w-[24px] h-[24px]',
  SPINNER_SIZE: '24px',
} as const;
